import { BoundaryCharacteristicSIDefinitions } from '@cadstrom/sigma-engine-shared';

import { roundToInterval } from '#utils/round-to-interval.js';

import type { BoundaryCharacteristic, CharacteristicValue } from '@cadstrom/sigma-engine-shared';

export function getCharacteristicSummaryString(
	characteristic: BoundaryCharacteristic,
	value: CharacteristicValue,
	precision = 3,
) {
	let rangeStr = '';
	if (value.allowableRange.min !== undefined && value.allowableRange.max !== undefined) {
		rangeStr = `${toPrecisionForCharacteristic(characteristic, value.allowableRange.min, precision)} to ${toPrecisionForCharacteristic(characteristic, value.allowableRange.max, precision)}${BoundaryCharacteristicSIDefinitions[characteristic].short}`;
	} else if (value.allowableRange.min !== undefined) {
		rangeStr = ` >= ${toPrecisionForCharacteristic(characteristic, value.allowableRange.min, precision)}${
			BoundaryCharacteristicSIDefinitions[characteristic].short
		}`;
	} else if (value.allowableRange.max !== undefined) {
		rangeStr = ` <= ${toPrecisionForCharacteristic(characteristic, value.allowableRange.max, precision)}${
			BoundaryCharacteristicSIDefinitions[characteristic].short
		}`;
	}

	if (value.value !== undefined) {
		let voltageStr = `${toPrecisionForCharacteristic(characteristic, value.value, precision)}${
			BoundaryCharacteristicSIDefinitions[characteristic].short
		}`;
		if (rangeStr.length > 0) {
			voltageStr += ` (${rangeStr})`;
		}

		return voltageStr;
	}

	return rangeStr;
}

export function toPrecisionForCharacteristic(characteristic: BoundaryCharacteristic, value: number, precision = 3) {
	if (BoundaryCharacteristicSIDefinitions[characteristic].epsilon !== undefined) {
		value = roundToInterval(value, BoundaryCharacteristicSIDefinitions[characteristic].epsilon);
	}

	return value.toPrecision(precision);
}
